export default import.meta.ROLLDOWN_FILE_URL_boCyqtvRJGsqAj3hj48oKA